<template>
    <div class="text-sm mb-3 shadow border border-gray-200 rounded">
        <div class="py-2 px-3 bg-white rounded-t" :class="cardVariantHeader">
            <div class="flex items-center">
                <span class="w-5 mr-2 flex-none">
                    <slot name="icon">
                        <component :is="cardVariantIcon" class="w-full" :class="cardVariantIconStyle" />
                    </slot>
                </span>
                <span class="flex-1 flex items-center">
                    <span class="flex-1">
                        <slot name="title">
                            <h2>{{ title }}</h2>
                        </slot>
                    </span>
                    <span class="flex-initial" v-if="$slots.actions">
                        <slot name="actions" />
                    </span>
                </span>
            </div>
        </div>
        <div class="px-3 py-3 bg-white rounded-b">
            <slot />
        </div>
    </div>
</template>

<script>
import DangerIcon from "@/Icons/Medium/DangerIcon.vue";
import InfoIcon from "@/Icons/Medium/InfoIcon.vue";
import CheckIcon from "@/Icons/Small/CheckIcon.vue";
import AnnotationIcon from "@/Icons/Small/AnnotationIcon.vue";

export default {
    name: "Card",
    components: {DangerIcon, InfoIcon, CheckIcon, AnnotationIcon},
    props: {
        title: String,
        headingClasses: String,
        variant: {
            type: String,
            default: 'primary',
            validator (value) {
                return ['danger', 'info', 'primary', 'success'].indexOf(value) !== false;
            }
        }
    },
    computed: {
        cardVariantIcon () {
            switch (this.variant) {
                case 'danger':
                    return 'DangerIcon';
                case 'success':
                    return 'CheckIcon';
                case 'info':
                    return 'InfoIcon';
                case 'primary':
                    return 'AnnotationIcon';
            }
        },
        cardVariantIconStyle () {
            switch (this.variant) {
                case 'danger':
                    return 'text-red-500';
                case 'success':
                    return 'text-green-400';
                case 'info':
                    return 'text-blue-500';
                case 'primary':
                    return 'text-primary';
            }
        },
        cardVariantHeader () {
            return {
                'text-red-500 border-b-2 border-red-500': this.variant === 'danger',
                'text-green-500 border-b border-green-500': this.variant === 'success',
                'text-primary border-b border-primary': this.variant === 'primary',
                'text-blue-500 border-b border-blue-500': this.variant === 'info',
            }
        }
    }
}
</script>

<style scoped>

</style>
